import axiosInstance from "@/utils/axios";
import guestAxios from "@/utils/guestAxios";

export const billingApi = {
  getBillByGuestSession: (guestSessionId) =>
    axiosInstance.get(`/api/admin/billing/guest-sessions/${guestSessionId}/bill`),

  generateDraftBill: (guestSessionId, payload = {}) =>
    axiosInstance.post(
      `/api/admin/billing/guest-sessions/${guestSessionId}/generate-draft`,
      payload
    ),

  recalculateBill: (billId, payload = {}) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/recalculate`, payload),

  issueBill: (billId) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/issue`),

  addManualCharge: (billId, payload) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/manual-charge`, payload),

  addAdjustment: (billId, payload) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/adjustment`, payload),

  addPayment: (billId, payload) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/payments`, payload),

  voidPayment: (paymentId, payload) =>
    axiosInstance.post(`/api/admin/billing/payments/${paymentId}/void`, payload),

  emailBill: (billId, payload) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/email`, payload),

  getAuditLogs: (billId) =>
    axiosInstance.get(`/api/admin/billing/bills/${billId}/audit-logs`),

  getBillLedger: (billId) =>
    axiosInstance.get(`/api/admin/billing/bills/${billId}/ledger`),

  getOnlinePaymentTransactions: (billId) =>
    axiosInstance.get(`/api/admin/billing/bills/${billId}/online-payment-transactions`),

  initiateOnlinePayment: (billId, payload = {}) =>
    axiosInstance.post(`/api/admin/billing/bills/${billId}/payments/initiate-online`, payload),

  getBillById: (billId) =>
    axiosInstance.get(`/api/admin/billing/bills/${billId}`),

  getBills: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/bills", { params: filters }),

  getRevenueSummary: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/revenue-summary", { params: filters }),

  getRevenueByAccount: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/revenue-by-account", { params: filters }),

  getDailyRevenue: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/revenue-daily", { params: filters }),

  getOutstandingBalances: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/outstanding-balances", { params: filters }),

  getRevenueTrends: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/analytics/revenue-trends", { params: filters }),

  getRoomRevenueAnalytics: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/analytics/room-revenue", { params: filters }),

  getPaymentMethodAnalytics: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/analytics/payment-methods", { params: filters }),

  getOutstandingAging: (filters = {}) =>
    axiosInstance.get("/api/admin/billing/analytics/outstanding-aging", { params: filters }),

  downloadInvoice: (billId) =>
    axiosInstance.get(`/api/admin/billing/bills/${billId}/invoice/download`, {
      responseType: "blob",
    }),

  getMyBill: () => guestAxios.get("/api/guest-portal/billing/my-bill"),

  getGuestPaymentOptions: () =>
    guestAxios.get("/api/guest-portal/billing/payment-options", {
      skipGuestAuthRedirect: true,
    }),

  initiateGuestOnlinePayment: (payload = {}) =>
    guestAxios.post("/api/guest-portal/billing/my-bill/payments/initiate-online", payload, {
      skipGuestAuthRedirect: true,
    }),

  downloadMyInvoice: () =>
    guestAxios.get("/api/guest-portal/billing/my-bill/invoice/download", {
      responseType: "blob",
      skipGuestAuthRedirect: true,
    }),
};
